import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Item, Indicator, Root } from '@radix-ui/react-radio-group';
import PropTypes from 'prop-types';
import { easing } from './lib/easing';

const StyledItem = styled(Item)`
  all: unset;
  border-radius: 100%;
  border: 2px solid var(--radio);
  height: 12px;
  max-width: 12px;
  min-width: 12px;
  transition: ${easing('background-color', 'border-color', 'box-shadow')};

  &:hover {
    border-color: var(--radio-hover);
  }

  &:focus {
    background: var(--radio-selected-focus-bg);
    box-shadow: 0 0 0 5px var(--radio-selected-focus-bg);
    outline: none;
  }

  &[data-state='checked'] {
    border: 2px solid var(--radio-checked);
  }

  &:disabled {
    border-color: var(--radio-disabled);
  }
`;

const StyledIndicator = styled(Indicator)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  &::after {
    content: '';
    background-color: var(--radio-checked);
    border-radius: 100%;
    display: block;
    height: 8px;
    width: 8px;

    @keyframes appear {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    animation: ${easing('appear')};
  }
`;

export const Control = styled.div`
  align-items: center;
  display: flex;
  gap: 0.8em;
  min-height: 40px;
  padding: 12px 24px;
  position: relative;
  user-select: none;

  &:hover {
    background-color: var(--radio-group-hover);
    border-radius: 6px;
  }
`;

export const Label = styled.label`
  color: var(--pleather);
  cursor: pointer;
  font-weight: var(--normal);
`;

const Radio = forwardRef((props, ref) => (
  <StyledItem {...props} ref={ref}>
    <StyledIndicator />
  </StyledItem>
));

Radio.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
};

Radio.displayName = 'Radio';

export default styled(Radio)``;
export const Group = styled(Root)``;

Group.displayName = 'RadioGroup';
